/**
 * @file interceptor.js
 * @author fengpan
 */

import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getCookie } from '@/common/js/utils/cookie';
import ksBridge from '@/common/js/ksBridge';
import yoda from '@ks/yoda-js-sdk';
import YodaKuaishouPlugin from '@ks/yoda-kuaishou-plugin';
yoda.plugin(YodaKuaishouPlugin);

// axios默认配置
axios.defaults.baseURL = '';
axios.defaults.method = 'get';
axios.defaults.timeout = 60 * 1000;
axios.defaults.withCredentials = true; // 让ajax携带cookie

interface AxiosConfig extends AxiosRequestConfig {
    showToast: boolean
}

let saveFun: Function;

ksBridge.on({
    type: 'h5_kwai_captcha_pass_token',
    handler: function (data: any)  {
        const token = data.token;
        saveFun(token);
    }
});
 
// 拦截器
axios.interceptors.request.use(
    config => {
        // 预定义头部
        const headerParams = {};
        config.headers = Object.assign({}, config.headers, headerParams);
        if (!getCookie('kpn')) {
            config.params = {
                kpn: 'KUAISHOU',
                ...config.params
            };
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
),
axios.interceptors.response.use(
    response => {
        return axiosInterceptorsHandler(response);
    },
    error => {
        return Promise.reject(error);
    }
);

// 滑块拦截
function axiosInterceptorsHandler(response: AxiosResponse){
    return new Promise(async (resolve, reject) => {
        const body = response.data;
        const config = response.config as AxiosConfig;
        if (body.result === 2001 || body.result === 100102) {
            saveFun = (token: string) => {
                if(config.headers){
                    config.headers.captchaToken = token;
                }
                setTimeout(() => {
                    resolve(axios(config));
                });
            };
            // 打开滑块
            const env = process.env.NODE_ENV === 'development' || process.env.NODE_BUILD === 'test';
            const domain = env ? 'https://captcha.staging.kuaishou.com' : 'https://captcha.zt.kuaishou.com';
            const url = `${domain}/mobile/app/index.html?passDataMethod=event&type=${body.type}&captchaSession=${body.captchaSession}&url=${encodeURIComponent(body.url)}`;
            // 滑块验证后会关闭页面webview，关闭后如果遇到验证失败需要再次验证的时候
            // 会重新吊起loadUrlOnNewPage，但是如果重新吊起的间隔时间过短，快手会忽略本次吊起，所以加500ms延迟
            setTimeout(() => {
                ksBridge.loadUrlOnNewPage({ url, type: 'back' });
            }, 500);
            return;
        } else {
            resolve(response);
        }
    });
}